export const getPtDomainByEnvironment = (env: string) => {
  if (!env) {
    throw new Error(
      `No STAGE environment variable found for Web Domain, env: ${env}`
    );
  }

  if (env.toLowerCase().startsWith("dev") || env.startsWith("cytest")) {
    return "http://localhost:3000";
  } else if (env === "Prod") {
    return "https://pt.rightmovehealth.com";
  }

  return `https://pt.${env.toLocaleLowerCase()}.rightmovehealth.com`;
};

export const getPatientAppDomainByEnvironment = (env: string) => {
  if (!env) {
    throw new Error(
      `No STAGE environment variable found for Patient App Domain, env: ${env}`
    );
  }

  if (env.toLowerCase().startsWith("dev") || env.startsWith("cytest")) {
    return "http://localhost:3000";
  } else if (env === "Prod") {
    return "https://app.rightmovehealth.com";
  }

  return `https://${env.toLocaleLowerCase()}.rightmovehealth.com`;
};

export const getAdminDomainByEnvironment = (env?: string) => {
  if (!env) {
    throw new Error(
      `"No STAGE environment variable found for Admin Domain, env: ${env}`
    );
  }

  if (env.toLowerCase().startsWith("dev") || env.startsWith("cytest")) {
    return "http://localhost:3001";
  } else if (env === "Prod") {
    return "https://ad.rightmovehealth.com";
  }

  return `https://ad.${env.toLocaleLowerCase()}.rightmovehealth.com`;
};

// Canvas has exactly two instances (dev + prod), so the host is chosen from a
// fixed allowlist — never interpolated from untrusted input.
export const getCanvasBaseUrlByEnvironment = (env?: string) => {
  if (!env) {
    throw new Error(
      `No STAGE environment variable found for Canvas Base URL, env: ${env}`
    );
  }

  return env === "Prod"
    ? "https://rightmovehealth.canvasmedical.com"
    : "https://rightmovehealth-dev.canvasmedical.com";
};

// Canvas FHIR patient ids are alphanumeric with `. _ -`. Reject anything else
// so a malformed/hostile value can't inject a path, query, or scheme.
const CANVAS_PATIENT_ID_PATTERN = /^[A-Za-z0-9._-]+$/;

export const buildCanvasPatientUrl = (
  env: string,
  canvasPatientId: string
): string | null => {
  // Fail closed on any invalid input — a missing env or a malformed id yields
  // no link rather than throwing, so a config gap never derails the caller's
  // success/redirect flow.
  if (
    !env ||
    !canvasPatientId ||
    !CANVAS_PATIENT_ID_PATTERN.test(canvasPatientId)
  ) {
    return null;
  }

  return `${getCanvasBaseUrlByEnvironment(env)}/patient/${encodeURIComponent(
    canvasPatientId
  )}`;
};

// Every stage talks to these hosts: our environments are separate Kemtai
// organizations behind one set of hosts, resolved by the API key.
export const KEMTAI_CONFIG = {
  apiBaseUrl: "https://api.kemtai.com",
  embedOrigin: "https://embed.kemtai.com",
  careManageUrl: "https://care-manage.kemtai.com",
} as const;
